exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/audioBtn.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"audioBtn.vue","sourcesContent":["\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40a2ff84","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Shared/audioBtn.vue
// module id = 230
// module chunks = 0 1 2 3 4 5 7 8